class ParallaxBackground {
  constructor(ctx, width, height, images) {
    this.ctx = ctx;

    this.width = width;
    this.height = height;

    this.images = images.map((src) => {
      const img = new Image();
      img.src = src;
      return img;
    });
    
    this.layers = this.images.map((img, index) => {
      return {
        image: img,
        alpha: 1 - 0.2 * index,
        speed: 0.05 + 0.05 * index,
        position: 0,
      };
    });
  }

  update(deltaTime) {
    this.layers.forEach((layer) => {
      layer.position += layer.speed * deltaTime;
      if (layer.position > this.height) layer.position = 0;
    });
  }

  draw() {
    this.layers.forEach((layer) => {
      if (this.ctx) this.ctx.globalAlpha = layer.alpha;
      if (this.ctx)
        this.ctx.drawImage(
          layer.image,
          0,
          layer.position - this.height,
          this.width,
          this.height
        );
      if (this.ctx)
        this.ctx.drawImage(
          layer.image,
          0,
          layer.position,
          this.width,
          this.height
        );
    });
    if (this.ctx) this.ctx.globalAlpha = 1;
  }
}

export { ParallaxBackground };
